import styled from 'styled-components';
import { Tooltip } from 'react-bootstrap';
import dt from '../../../shared/theme';

const HintTooltip = styled(Tooltip)`
  z-index: 3;

  & > .tooltip-inner {
    background-color: ${props => dt(props).theme.bodyColor};
    width: 300px;
    padding: 24px 16px 16px;
    box-shadow: 0px 12px 12px rgba(50, 50, 71, 0.08), 0px 16px 24px rgba(50, 50, 71, 0.08);
    border: none;
    border-radius: 6px;
  }

  & > .arrow {
    position: absolute;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  color: ${props => dt(props).theme.bodyBackgroundColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 16px;
  line-height: 100%;
  margin-bottom: 6px;

  .icon-lw-info-circle {
    font-size: 16px;
    float: right;
  }
`;

const Description = styled.div`
  color: #BBCBD8;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  font-size: 16px;
  line-height: 130%;
  max-width: 240px;
`;

const Button = styled.button`
  background-color: ${props => dt(props).theme.bodyBackgroundColor};
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 14px;
  line-height: 120%;
  text-transform: uppercase;
  width: 71px;
  height: 30px;
  border: none;
  border-radius: 4px;
  margin-top: 24px;
`;

export {
  HintTooltip,
  Container,
  Title,
  Description,
  Button,
};
